<!--
 * @Author: zhaoyian zhaopeng1957462481@163.com
 * @Date: 2023-11-09 20:04:03
 * @LastEditors: zhaoyian zhaopeng1957462481@163.com
 * @LastEditTime: 2023-11-14 17:09:38
 * @FilePath: \yunque\src\App.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <router-view></router-view>
</template>

<script>

export default {
  name: 'App',
  components: {
  },
  mounted() {
    this.setFontSize()
    window.onresize = () => {
      this.setFontSize()
    }
  },
  methods: {
    computedFontStyle(clientWidth, designWidth, multiple = 1) {
      return clientWidth / designWidth * multiple
    },
    setFontSize() {
      // 获取html对象
      const docEl = document.documentElement;
      // 获取网页宽度
      let clientWidth = docEl.clientWidth;
      let rootFontStyle = 0;
      rootFontStyle = this.computedFontStyle(clientWidth, 1920);
      document.getElementsByTagName('html')[0].style.fontSize = `${rootFontStyle}px`;
    }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin: 0px;
  padding: 0px;
}

body {
  padding: 0px;
  margin: 0px;
  font-size: 16rem;
}

body::-webkit-scrollbar {
  width: 0;
}
 
.el-popup-parent--hidden {
  padding-right: 0px !important;
  overflow: hidden !important;
  width: 100%!important;
}
</style>
